import type { ReactNode } from 'react'
import { TopBar } from '../components/TopBar'
import { Header } from './Header'
import { Footer } from '../components/Footer'
import { CartDrawer } from '@/modules/cart'
import { useMe } from '@/modules/auth-api'
import { useCartSync } from '@/modules/cart-api'
import { useAutoFetchPromo, useAutoFetchArticles } from '@/modules/promo/config/useLivePromo'

interface AppShellProps {
  children: ReactNode
}

export function AppShell({ children }: AppShellProps) {
  useMe()
  useCartSync()
  useAutoFetchPromo()
  useAutoFetchArticles()
  return (
    <div className="min-h-screen flex flex-col bg-bg">
      <TopBar />
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
      <CartDrawer />
    </div>
  )
}
